import { render, staticRenderFns } from "./ProcessamentoArquivosPagamento.vue?vue&type=template&id=07845af6&"
import script from "./ProcessamentoArquivosPagamento.vue?vue&type=script&lang=js&"
export * from "./ProcessamentoArquivosPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports